import { Link } from 'react-router-dom';
import { getTopRatedComics, getLatestComics } from '@/mocks/comics';
import RankingList from '@/components/base/RankingList';
import ComicCard from '@/components/base/ComicCard';

export default function RankingAndLatest() {
  const topRated = getTopRatedComics(10);
  const latest = getLatestComics(6);

  return (
    <section className="py-10 md:py-14">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
          <div className="lg:col-span-1">
            <RankingList comics={topRated} title="排行榜" icon="ri-fire-line" />
          </div>

          <div className="lg:col-span-2">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-xl md:text-2xl font-heading text-foreground-900">
                最新更新
              </h2>
              <Link
                to="/category/action"
                className="text-sm text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1 whitespace-nowrap"
                onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
              >
                查看更多 <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4 md:gap-5">
              {latest.map((comic) => (
                <ComicCard key={comic.id} comic={comic} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}